import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DianService } from '@app/services/dian.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-empresa-form',
  templateUrl: './empresa-form.component.html',
  styleUrls: ['./empresa-form.component.css']
})
export class EmpresaFormComponent implements OnInit {
  companyForm: FormGroup;
  form: FormGroup;
  fileName: string | null = null;
  TypeDocuments: [] = [];
  typeOperations: [] = [];
  typeLiabilities: [] = [];
  taxDetail: [] = [];
  dataBussines: [] = [];
  existsBussines: boolean = false;

  constructor(private fb: FormBuilder, private dianService: DianService) {}

  ngOnInit() {
    this.form = this.fb.group({
      password: ['', Validators.required],
      extension: [{ value: '', disabled: true }],
      file: [null, Validators.required]
    });

    this.companyForm = this.fb.group({
      type_document_identification_id: [0, Validators.required],
      identification_number: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      dv: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      name: ['', [Validators.required, Validators.minLength(3)]],
      commercial_name: [''],
      language_id: [0, Validators.required],
      type_environment_id: [0, Validators.required],
      type_organization_id: [0, Validators.required],
      type_operation_id: [0, Validators.required],
      type_currency_id: [0, Validators.required],
      type_liability_id: [0, Validators.required],
      tax_detail_id: [0, Validators.required],
      phone: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      email: ['', [Validators.required, Validators.email]],
      address: ['', [Validators.required, Validators.minLength(5)]],
      country_id: [0, Validators.required],
      municipality_id: [0, Validators.required],
      merchant_registration: ['', Validators.required],
      portal_zone_location: ['', Validators.required],
      ciiu: ['', Validators.required]
    });

    this.getTypeDocuments();
    this.getTypeOperation();
    this.getTypeLiabilities();
    this.getTaxDetail();
    this.getEmpresaById();
  }

  postEmpresa(): void {
    if (this.companyForm.valid) {
      let data = this.companyForm.getRawValue();
      this.dianService.postEmpresa(data).subscribe(
        resp => {
          swal('¡Registro exitoso!', 'La empresa ha sido registrada correctamente.', 'success');
        },
        error => {
          swal('Error', 'Ocurrió un problema al registrar la empresa.', 'error');
        }
      );
    } else {
      swal('Formulario incompleto', 'Por favor, completa todos los campos requeridos antes de enviar.', 'warning');
    }
  }

  putEmpresa(): void {
    if (this.companyForm.valid) {
      let data = this.companyForm.getRawValue();
      this.dianService.putEmpresa(890110844, data).subscribe(
        resp => {
          swal('¡Actualización exitosa!', 'La empresa ha sido actualizada correctamente.', 'success');
        },
        error => {
          swal('Error', 'Ocurrió un problema al actualizar la empresa.', 'error');
        }
      );
    } else {
      swal('Formulario incompleto', 'Por favor, completa todos los campos requeridos antes de enviar.', 'warning');
    }
  }

  getEmpresaById(): void {
    this.dianService.getEmpresaById(890106966).subscribe(data => {
      this.dataBussines = data;

      if (this.dataBussines) {
        this.existsBussines = true;
        this.companyForm.patchValue({
          type_document_identification_id: data.typeDocumentIdentificationId,
          identification_number: data.identificationNumber,
          dv: data.dv,
          name: data.name,
          commercial_name: data.commercialName || '',
          language_id: data.languageId,
          type_environment_id: data.typeEnvironmentId,
          type_organization_id: data.typeOrganizationId,
          type_operation_id: data.typeOperationId,
          type_currency_id: data.typeCurrencyId,
          type_liability_id: data.typeLiabilityId,
          tax_detail_id: data.taxDetailId,
          phone: data.phone,
          email: data.email,
          address: data.address,
          country_id: data.countryId,
          municipality_id: data.municipalityId,
          merchant_registration: data.merchanRegistration,
          portal_zone_location: data.portalZoneLocation,
          ciiu: data.ciiu
        });
      }
    });
  }

  getTypeDocuments(): void {
    this.dianService.getTypeDocuments().subscribe(resp => {
      this.TypeDocuments = resp;
    });
  }

  getTypeOperation(): void {
    this.dianService.gettypeOperation().subscribe(resp => {
      this.typeOperations = resp;
    });
  }

  getTypeLiabilities(): void {
    this.dianService.gettypeLiabilities().subscribe(resp => {
      this.typeLiabilities = resp;
    });
  }

  getTaxDetail(): void {
    this.dianService.gettaxDetail().subscribe(resp => {
      this.taxDetail = resp;
    });
  }

  postGenerarCertificado(): void {
    let data = {
      identification_number: this.companyForm.get('identification_number').value,
      password: this.form.get('password').value,
      extension: this.form.get('extension').value,
      certificate: this.form.get('file').value
    };

    this.dianService.postGenerarCertificado(data).subscribe(
      resp => {
        swal('¡Certificado generado!', 'El certificado ha sido generado exitosamente.', 'success');
      },
      error => {
        swal('Error', 'Ocurrió un problema al generar el certificado.', 'error');
      }
    );
  }
}
